import React from "react";
import { useStudentCredits } from "../../StudentCreditsContext";

const NotEnoughCredits = ({ onClose }) => {
  const { setIsPurchaseCreditsOpen } = useStudentCredits();

  return (
    <>
      <div className="text-2xl font-bold text-black">
        Sorry, you don’t have enough credits
      </div>

      <div className="text-base text-grayTrue700 mt-2">
        You need at least 1 available credit to apply to your students
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose();
          setIsPurchaseCreditsOpen(true);
        }}
        className="w-full min-h-11 h-11 rounded-full font-semibold text-sm btnPrimary500 mt-4"
      >
        Add credits
      </button>

      <button
        onClick={onClose}
        className="w-full min-h-11 h-11 rounded-full font-semibold text-sm btnGray100 mt-2"
      >
        Nevermind
      </button>
    </>
  );
};

export default NotEnoughCredits;
